export default __webpack_public_path__ + "static/media/Leggings of Light Unpresent.880f4083.jpg";